<template>
  <div class="popup-content">
    <vs-tabs v-model="currentTab" class="tabs">
      <vs-tab label="General">
        <GeneralTab :onboarding="onboarding"></GeneralTab>
      </vs-tab>
      <vs-tab label="Triggers">
        <TriggersTab :onboarding="onboarding"></TriggersTab>
      </vs-tab>
      <vs-tab label="Advanced">
        <AdvancedTab :onboarding="onboarding"></AdvancedTab>
      </vs-tab>
    </vs-tabs>
    </div>
</template>

<script>
  import GeneralTab from '@/views/ui-elements/tabs/GeneralTab.vue'
  import TriggersTab from '@/views/ui-elements/tabs/TriggersTab.vue'
  import AdvancedTab from '@/views/ui-elements/tabs/AdvancedTab.vue'
  export default {
  props:["onboarding"],
  
  data() {
    return {
    };
    },

  computed: {
    currentTabComponent() {
      return this.currentTab;
    }

  },
  components: {
    TriggersTab,
    GeneralTab,
    AdvancedTab
  },
  methods: {
    closePopup() {
      this.$emit('close');
    },
    selectTab(tab) {
      this.currentTab = tab;
    }
  },


};
</script>

<style scoped>
  .tt-text {
    width: 96px;
    height: 32px;
    display: inline-block;
    
    cursor: pointer;
    text-align: center;
    padding: 3px;
    border-radius: 5px;
    border: 1px solid grey;
    background: #fff;
    color: #000;
    font-weight: 700;
    cursor: pointer;
    
    min-width: 33px;
    height: 33px !important;
    vertical-align: top;

  }
  
</style>
